<script setup lang="ts">
import { computed, provide, ref, toRefs } from 'vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import UboLayout from '@relatie-lib/ubo/UboLayout.vue';
import { useRelatiesGetRelationByRelatienummer } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import { useWatchErrorHandler } from '@errors/useErrorHandler';
import { toonUboCheckResultatenInjectionKey } from '@relatie-lib/ubo/keys';
import RelatiegegevensHistorieModal from '@crm-lib/relatiegegevens/tabs/modals/RelatiegegevensHistorieModal.vue';
import { VButton } from '@shared/component/VButton';
import { useClaims } from '@auth/useClaims';
import { hasPermission } from '@permission/hasPermission';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);

const claims = useClaims();
const isInterneGebruiker = computed(() => claims.value?.isInternal ?? false);
const magBijwerken = hasPermission('Crm.UboBijwerken');

const { data: relatieId, error } = useRelatiesGetRelationByRelatienummer(relatienummer, {
  query: {
    select: (r) => r.result?.id,
  },
});

useWatchErrorHandler(error);

provide(toonUboCheckResultatenInjectionKey, { value: ref(true) });

const isLogboekOpen = ref<boolean>(false);
</script>

<template>
  <VPageContainer container-size="sm" title="UBO">
    <template v-if="isInterneGebruiker" #actions>
      <VButton
        prepend-icon="far fa-timeline"
        icon-only-responsiveness
        class="mb-4"
        inverted
        @click="isLogboekOpen = true"
      >
        Logboek
      </VButton>
    </template>

    <RelatiegegevensHistorieModal
      :relatienummer
      titel="Logboek"
      omschrijving="Alle wijzigingen aan de UBO's en checkresultaten voor de UBO's verschijnen hier."
      :filter="(log) => log.type === 'Ubo'"
      v-model:is-open="isLogboekOpen"
      v-if="isLogboekOpen"
    />

    <UboLayout
      v-if="!!relatieId"
      :relatie-id="relatieId"
      :readonly="!isInterneGebruiker || !magBijwerken"
      context="Relatie"
      should-confirm-removal
    />
  </VPageContainer>
</template>
